import { ActionTypes } from './actionTypes';

export const toggleSidenav = (data) => {
  return {
    type: ActionTypes.TOGGLE_SIDENAV,
    payload: data,
  };
};
